import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
export const FAQ = () => {
  return <section className="mb-10" data-id="element-49">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-50">
        Veelgestelde Vragen Over Het Webinar
      </h2>
      <div className="space-y-6" data-id="element-51">
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-52">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-53">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-54" />
            <h3 className="font-bold" data-id="element-55">"Hoe werkt een online webinar?"</h3>
          </div>
          <div className="p-4" data-id="element-56">
            <p className="leading-relaxed" data-id="element-57">
              Na je registratie ontvang je een bevestigingsmail met een unieke
              link. Op de dag van het webinar klik je simpelweg op deze link om
              deel te nemen. Je hebt alleen een internetverbinding en een
              apparaat (computer, tablet of smartphone) nodig.
            </p>
            <p className="leading-relaxed mt-2" data-id="element-58">
              Je kunt het webinar live volgen, vragen stellen via de chat, en na
              afloop is er een exclusieve Q&A-sessie waar ik persoonlijk je
              vragen beantwoord.
            </p>
          </div>
        </div>
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-59">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-60">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-61" />
            <h3 className="font-bold" data-id="element-62">"Is dit webinar echt gratis?"</h3>
          </div>
          <div className="p-4" data-id="element-63">
            <p className="leading-relaxed" data-id="element-64">
              Ja, het webinar is 100% gratis. Er zijn geen verborgen kosten of
              verplichtingen. Mijn doel is om zoveel mogelijk hondenbaasjes te
              helpen met deze waardevolle informatie.
            </p>
            <p className="leading-relaxed mt-2" data-id="element-65">
              Aan het einde van het webinar zal ik kort mijn volledige cursus
              'Liefdevol Communiceren' introduceren voor wie dieper wil gaan,
              maar dit is volledig optioneel.
            </p>
          </div>
        </div>
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-66">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-67">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-68" />
            <h3 className="font-bold" data-id="element-69">"Wat als ik niet live kan kijken?"</h3>
          </div>
          <div className="p-4" data-id="element-70">
            <p className="leading-relaxed" data-id="element-71">
              Als je je registreert maar niet live kunt kijken, krijg je 48 uur
              toegang tot de opname. Zo kun je het webinar alsnog bekijken op
              een moment dat jou uitkomt. Je mist dan wel de live Q&A, maar je
              kunt alsnog veel waardevolle informatie opdoen.
            </p>
          </div>
        </div>
      </div>
    </section>;
};